var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widthFull back-1 h-100", attrs: { id: "home" } },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container-fluid heroHome relative",
          attrs: { id: "top" }
        },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-3" }, [
              _vm.vw > 991
                ? _c("img", {
                    ref: "mainNavLogo",
                    staticClass: "img-fluid logoMob animatedLogo ml-4",
                    attrs: { src: require("../../assets/images/logo.png") }
                  })
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row justify-content-center mt-lg-5 pt-lg-5" },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 col-lg-4 mb-5 pb-4 pt-lg-5" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "Title h0 uppercase headerTitle mt-lg-5 pt-lg-5"
                  },
                  [
                    _c(
                      "h3",
                      {
                        staticClass: "black uppercase Medium pt-lg-4 pb-4",
                        class: { h5: _vm.vw < 600 }
                      },
                      [
                        _vm._v(
                          "\n            SCOPRI TUTTE LE ATTIVITÀ DI\n            "
                        ),
                        _c("b", { staticClass: "Bold" }, [
                          _vm._v("LABORATOIRE NATIVE")
                        ]),
                        _vm._v(
                          " RISERVATE ALLE FARMACIE E\n            AI PUNTI VENDITA ADERENTI\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.isAuthenticated &&
                    _vm.moment(_vm.now, "DD-MM-YYYY") >=
                      _vm.moment(_vm.start_intermedio, "DD-MM-YYYY")
                      ? _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "scroll-to",
                                rawName: "v-scroll-to",
                                value: { el: "#active", offset: -85 },
                                expression: "{ el: '#active', offset: -85 }"
                              }
                            ],
                            staticClass: "btn Bold btn-primary"
                          },
                          [_vm._v("Scopri di piú")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isAuthenticated &&
                    _vm.moment(_vm.now, "DD-MM-YYYY") <=
                      _vm.moment(_vm.start_intermedio, "DD-MM-YYYY")
                      ? _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "scroll-to",
                                rawName: "v-scroll-to",
                                value: { el: "#coming_soon", offset: -85 },
                                expression:
                                  "{ el: '#coming_soon', offset: -85 }"
                              }
                            ],
                            staticClass: "btn Bold btn-primary"
                          },
                          [_vm._v("Scopri di piú")]
                        )
                      : !_vm.isAuthenticated
                      ? _c(
                          "router-link",
                          {
                            staticClass: "btn btn-primary Bold",
                            attrs: { to: "/login", href: "#active" }
                          },
                          [_vm._v("Effettua il login")]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.isAuthenticated
        ? _c("Active", {
            staticClass: "zIndex2 relative",
            attrs: { id: "active" }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isAuthenticated
        ? _c("ComingSoon", {
            staticClass: "zIndex2 relative mb-5",
            attrs: { id: "coming_soon" }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isAuthenticated
        ? _c("NotActive", {
            staticClass: "zIndex2 relative mb-5",
            attrs: { id: "notActive" }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-12 col-lg-6 mt-5 mt-lg-0 pt-5 pt-lg-0 center " },
      [
        _c("img", {
          staticClass: "img-fluid img mt-4",
          attrs: { src: require("../../assets/images/home.png") }
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67f3a69c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67f3a69c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/index.vue
// module id = null
// module chunks = 